import React from "react";
import { Link } from "react-router-dom";

const BlockLink = ({ icon, url, title, summary }) => {
  return (
    <div className="block-link">
      <div className="icon">
        <i className={`fas ${icon}`}></i>
      </div>
      <p>
        <Link to={url}>{title}</Link>
        <br />
        {summary}
      </p>
    </div>
  );
};

export default BlockLink;
